<template>
  <form class="personal-details-form">
    <div class="user-name-fields form-field">
      <u-input :id="getNamespacedId('name')" :value="user.first_name" label="Voornaam" @input="updateField('first_name', $event)">
        <template v-slot:error>
          <p v-if="validations.first_name.$error">Dit veld is verplicht</p>
        </template>
      </u-input>
      <u-input :id="getNamespacedId('last-name')" :value="user.last_name" label="Achternaam" @input="updateField('last_name', $event)">
        <template v-slot:error>
          <p v-if="validations.last_name.$error">Dit veld is verplicht</p>
        </template>
      </u-input>
    </div>
    <u-input :id="getNamespacedId('email')" :value="user.email" label="E-mailadres" class="form-field" @input="updateField('email', $event)">
      <template v-if="validations.email.$error" v-slot:error>
        <p v-if="!validations.email.required">Dit veld is verplicht</p>
        <p v-if="validations.email.required && !validations.email.email">Voer een geldig e-mailadres in</p>
      </template>
    </u-input>
    <u-input :id="getNamespacedId('repeat-email')" :value="user.emailRepeat" label="Herhaal E-mailadres" class="form-field" @input="updateField('emailRepeat', $event)">
      <template v-if="validations.emailRepeat.$error" v-slot:error>
        <p v-if="!validations.emailRepeat.required">Dit veld is verplicht</p>
        <p v-if="validations.emailRepeat.required && !validations.emailRepeat.email">Voer een geldig e-mailadres in</p>
        <p v-if="validations.emailRepeat.required && validations.emailRepeat.email && !validations.emailRepeat.sameAs">E-mailadressen komen niet overeen</p>
      </template>
    </u-input>
  </form>
</template>

<script>

  import { mapState, createNamespacedHelpers } from 'vuex'
  import UInput from './UInput'

  export default {
    components: {
      UInput
    },
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapGetters } = createNamespacedHelpers(namespace)
      // computed 
      this.$options.computed = {
        ...(this.$options.computed || {}),
        ...mapGetters(['validations'])
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth.user
      }),
    },
    methods: {
      updateField (field, $event) {
        this.$store.commit('auth/SET_USER_FIELD', { field: field, value: $event })
      },
      getNamespacedId (id) {
        return `${this.namespace}-${id}`
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .user-name-fields {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 1em;
    grid-row-gap: 1.5em;

    @include screen(md) {
      grid-template-columns: repeat(2, 1fr);
    }

  }

  .form-field:not(:last-of-type) {
    padding-bottom: 1.5em;
  }

</style>